module.exports = {
  select: {
    empty_status: 0,  // 是否有空选项
    empty_value: '',  // 空值：1是0否
    has_search: 0 // 是否具有搜索功能
  },
  select_option: []
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/select.js